import React from 'react';
import { Award, Users, Zap, Shield } from 'lucide-react';

const About = () => {
  const yearsExperience = new Date().getFullYear() - 2006;

  const features = [
    {
      icon: <Award className="text-silver-300" size={32} />,
      title: 'Premium Quality',
      description: 'Industry-leading print quality with state-of-the-art equipment and materials.'
    },
    {
      icon: <Users className="text-silver-300" size={32} />,
      title: 'Expert Team',
      description: 'Experienced professionals dedicated to bringing your vision to life.'
    },
    {
      icon: <Zap className="text-silver-300" size={32} />,
      title: 'Fast Turnaround',
      description: 'Quick delivery without compromising on quality or attention to detail.'
    },
    {
      icon: <Shield className="text-silver-300" size={32} />,
      title: 'Trusted Service',
      description: 'Reliable and consistent results that exceed expectations every time.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-navy-700 to-navy-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            About <span className="text-silver-300">Our Company</span>
          </h2>
          <p className="text-xl text-silver-400 max-w-3xl mx-auto">
            Founded in 2006, we are a leading digital printing and packaging company committed to delivering exceptional quality 
            and service. Over the years, we have served a wide range of clients across India, supporting brands, 
            businesses, and institutions with reliable printing solutions. With proven expertise and cutting-edge 
            technology, we transform your ideas into stunning printed reality.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-navy-700/50 backdrop-blur-sm p-8 rounded-xl border border-silver-600/30 hover:border-silver-400/50 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold text-white mb-3">{feature.title}</h3>
              <p className="text-silver-400">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-3 gap-8 text-center">
          <div className="bg-gradient-to-br from-navy-600 to-navy-700 p-8 rounded-xl border border-silver-600/30">
            <p className="text-5xl font-bold text-silver-200 mb-2">{yearsExperience}+</p>
            <p className="text-silver-400 text-lg">Years Experience</p>
          </div>
          <div className="bg-gradient-to-br from-navy-600 to-navy-700 p-8 rounded-xl border border-silver-600/30">
            <p className="text-5xl font-bold text-silver-200 mb-2">10K+</p>
            <p className="text-silver-400 text-lg">Projects Completed</p>
          </div>
          <div className="bg-gradient-to-br from-navy-600 to-navy-700 p-8 rounded-xl border border-silver-600/30">
            <p className="text-5xl font-bold text-silver-200 mb-2">98%</p>
            <p className="text-silver-400 text-lg">Client Satisfaction</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
